import { useQuery } from "@tanstack/react-query";
import { graphqlClient } from "@/lib/graphql-client";
import { CompanyQuery } from "@/queries";
import type { Company } from "@repo/types";

export function useCompany() {
  return useQuery<Company>({
    queryKey: ["company"],
    queryFn: () =>
      graphqlClient
        .request<{ company: Company }>(CompanyQuery)
        .then((res) => res.company),
  });
}
